import React, { useState } from 'react';
import { CellId } from '../../../ui/DataTable/cells';
import FineDetailsModal from './FineDetailsModal';
import CustomerProfileModal from '../../../components/CustomerProfileModal';

// Every register / remove dialog (owner, 7 Oct 2026): a fine number opens the fine, a contract number opens the
// customer 360 - one click to judge a row while the job runs. `useRowLinks()` gives the two link cells and the
// modals to render once at the dialog's end.
export function useRowLinks() {
    const [ticket, setTicket] = useState(null);
    const [seed, setSeed] = useState(null);
    const FineLink = ({ ticket: t }) => (
        <button type="button" className="text-purple-700 hover:underline underline-offset-2" onClick={(e) => { e.stopPropagation(); setTicket(String(t)); }} title="Open the fine">
            <CellId>{t}</CellId>
        </button>
    );
    const ContractLink = ({ contract, customer, plate }) => (
        <button type="button" className="text-purple-700 hover:underline underline-offset-2" title="Open the customer 360"
                onClick={(e) => { e.stopPropagation(); setSeed({ contractNo: contract, name: customer || '', plate: plate || '' }); }}>
            <CellId>{contract}</CellId>
        </button>
    );
    const modals = (
        <>
            {ticket && <FineDetailsModal ticket={ticket} onClose={() => setTicket(null)} />}
            <CustomerProfileModal open={!!seed} seed={seed} onClose={() => setSeed(null)} onCopy={() => {}} />
        </>
    );
    return { FineLink, ContractLink, modals };
}

/** The dialog's top block (the bar, the counts, Stop) stays in view while the rows scroll under it. */
export const stickyTop = 'sticky top-0 z-10 bg-white pb-2 -mt-1 pt-1';
